 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"AccountBankCardBranch":"AccountBankCardBranch","AccountBankChangeResult":"AccountBankChangeResult","AccountBankChangeinformationDetail":"AccountBankChangeinformationDetail","AccountCompleteCrsInformation":"AccountCompleteCrsInformation","AccountRealAuth":"AccountRealAuth","AccountRiskAssessment":"AccountRiskAssessment","AccountRiskAssessmentHold":"AccountRiskAssessmentHold","AccountRiskAssessmentResult2":"AccountRiskAssessmentResult2","AssetProof":"AssetProof","AssetProofEmail":"AssetProofEmail","AssetProofEmpty":"AssetProofEmpty","AssetProofPre":"AssetProofPre","AssetProofPrivate":"AssetProofPrivate","AssetProofSendFail":"AssetProofSendFail","AssetProofSendSuccess":"AssetProofSendSuccess","AuthenticationBankResult":"AuthenticationBankResult","ChooseBank":"ChooseBank","CommonAbout":"CommonAbout","CommonAboutContact":"CommonAboutContact","CommonAboutCredentials":"CommonAboutCredentials","CommonAboutIntroduce":"CommonAboutIntroduce","CommonAboutUs":"CommonAboutUs","CommonBulletin":"CommonBulletin","CommonBulletinDetail":"CommonBulletinDetail","CommonCustomerServiceRobot":"CommonCustomerServiceRobot","CommonDiffFundLoading":"CommonDiffFundLoading","CommonEmpty":"CommonEmpty","CommonIndex":"CommonIndex","CommonIndexHome":"CommonIndexHome","CommonLoading":"CommonLoading","CommonNotice":"CommonNotice","CommonNoticeNoticeDetail":"CommonNoticeNoticeDetail","CommonRuleContent":"CommonRuleContent","CommonRuleContent2":"CommonRuleContent2","CommonRuleMaintain":"CommonRuleMaintain","CommonRuleMultiple":"CommonRuleMultiple","CommonRuleRisk":"CommonRuleRisk","CommonRuleRiskLevel":"CommonRuleRiskLevel","CommonRuleSingle":"CommonRuleSingle","CommonSetting":"CommonSetting","CurrencyTradeRules":"CurrencyTradeRules","DownApp":"DownApp","FundBuyResultInstructions":"FundBuyResultInstructions","FundDetailAchievement":"FundDetailAchievement","FundDetailManager":"FundDetailManager","FundDetailNetValue":"FundDetailNetValue","FundDetailTradingRules":"FundDetailTradingRules","FundDetailTradingRulesNotice":"FundDetailTradingRulesNotice","FundRemittanceInstructions":"FundRemittanceInstructions","FundSellExpireDetail":"FundSellExpireDetail","FundTransformHold":"FundTransformHold","FundTransformRecommend":"FundTransformRecommend","FundTransformResult":"FundTransformResult","FundTransformSearch":"FundTransformSearch","GongGaoDetail":"GongGaoDetail","HomeGroupPage":"HomeGroupPage","HomeRankingList":"HomeRankingList","IncomeList":"IncomeList","InvestAdviseCommonQuestion":"InvestAdviseCommonQuestion","InvestAdviseConfig":"InvestAdviseConfig","InvestAdviseHistoryAchievement":"InvestAdviseHistoryAchievement","InvestAdviseIntroduce":"InvestAdviseIntroduce","InvestAdviseMatch":"InvestAdviseMatch","InvestAdvisePosition":"InvestAdvisePosition","InvestAdviseRecommend":"InvestAdviseRecommend","InvestAdviseReport":"InvestAdviseReport","InvestAdviseRiskDisclosure":"InvestAdviseRiskDisclosure","InvestAdviseTradeRules":"InvestAdviseTradeRules","InvestBuy":"InvestBuy","InvestSell":"InvestSell","InvestTransactionDetail":"InvestTransactionDetail","InvestTransactionLog":"InvestTransactionLog","InvestTransactionResult":"InvestTransactionResult","NetWorth":"NetWorth","OldBonusResult":"OldBonusResult","OldBuyResult":"OldBuyResult","OldElseResult":"OldElseResult","OldInvestResult":"OldInvestResult","OldPlanResult":"OldPlanResult","OldSellResult":"OldSellResult","PointsCenterRecords":"PointsCenterRecords","PositionReport":"PositionReport","ProgressTradeDetail":"ProgressTradeDetail","ProgressTradeList":"ProgressTradeList","ResignCardNotice":"ResignCardNotice","SearchSelfAdd":"SearchSelfAdd","SupportBank":"SupportBank","TransferDetail":"TransferDetail","TransferList":"TransferList","YiqianbaoCompany":"YiqianbaoCompany","YiqianbaoDetailDocument":"YiqianbaoDetailDocument","YiqianbaoDetailManager":"YiqianbaoDetailManager","YiqianbaoDetailNotice":"YiqianbaoDetailNotice","YiqianbaoIncome":"YiqianbaoIncome","YiqianbaoRecord":"YiqianbaoRecord","YiqianbaoRecordDetail":"YiqianbaoRecordDetail","YiqianbaoRecordDetail2":"YiqianbaoRecordDetail2","YiqianbaoRedeem":"YiqianbaoRedeem","YiqianbaoSellResult":"YiqianbaoSellResult","ZhishuBao":"ZhishuBao","activityModal":"activityModal","base-FOF":"base-FOF","libs-FOF":"libs-FOF","FOF":"FOF","FOFList":"FOFList","FundDetailDocument":"FundDetailDocument","FundQuarterReport":"FundQuarterReport","YiqianbaoDetail":"YiqianbaoDetail","incomeDetail":"incomeDetail","AccountAuthCenter":"AccountAuthCenter","AccountBankCard-AccountBankCardDetail":"AccountBankCard-AccountBankCardDetail","AccountBankCard":"AccountBankCard","AccountBankCardDetail":"AccountBankCardDetail","AccountBankChange":"AccountBankChange","AccountBankChangeForm":"AccountBankChangeForm","AccountBankChangeResultFail":"AccountBankChangeResultFail","AccountBankChangeinformation":"AccountBankChangeinformation","AccountBankSign":"AccountBankSign","AccountBindBank":"AccountBindBank","AccountCompleteInformation":"AccountCompleteInformation","AccountCompleteInformationControl":"AccountCompleteInformationControl","AccountLogin":"AccountLogin","AccountLoginPwd":"AccountLoginPwd","AccountLoginRegister":"AccountLoginRegister","AccountOcr":"AccountOcr","AccountOutMan":"AccountOutMan","AccountRegister":"AccountRegister","AccountRegisterSubcode":"AccountRegisterSubcode","AccountRiskAssessmentResult":"AccountRiskAssessmentResult","AccountTransPwd":"AccountTransPwd","AccountVerificationUser":"AccountVerificationUser","ActiveIndex":"ActiveIndex","AuthenticationBank":"AuthenticationBank","CommonSliderVertify":"CommonSliderVertify","FundBuyChaobaoPaymentResult":"FundBuyChaobaoPaymentResult","FundSell":"FundSell","FundTransform":"FundTransform","InvestSuitableQuestion":"InvestSuitableQuestion","NetWorthSearch":"NetWorthSearch","PointsCenterStore":"PointsCenterStore","ShareReal":"ShareReal","Yiqianbao":"Yiqianbao","YiqianbaoBuy":"YiqianbaoBuy","YiqianbaoBuyResult":"YiqianbaoBuyResult","YiqianbaoNoAsset":"YiqianbaoNoAsset","YiqianbaoSell":"YiqianbaoSell","CommonIndexMine":"CommonIndexMine","CommonIndexMineSelf":"CommonIndexMineSelf","CurrencyFundDetail":"CurrencyFundDetail","FundBuyResult":"FundBuyResult","FundDetail":"FundDetail","InvestAdviseDetail":"InvestAdviseDetail","InvestAdvisePositionDetail":"InvestAdvisePositionDetail","FundBuy":"FundBuy","newYqbNormaltBuy":"newYqbNormaltBuy","regularInvest":"regularInvest","myFundPosition":"myFundPosition","newFundDetail":"newFundDetail","newYqbBuyOrderSon":"newYqbBuyOrderSon","newYqbFunSelect":"newYqbFunSelect","newYqbSell":"newYqbSell","newYqbSmartBuy":"newYqbSmartBuy","newYqbSmartDetail":"newYqbSmartDetail","outsideTrustee":"outsideTrustee","regularInvestPlanDetail":"regularInvestPlanDetail","setBonus":"setBonus","transactionLogDetailViewSonDT":"transactionLogDetailViewSonDT","transactionLogDetailViewSonMR":"transactionLogDetailViewSonMR","transactionLogDetailViewSonRG":"transactionLogDetailViewSonRG","vendors-FundSellResult-newYqbBuyResult-newYqbSellResult":"vendors-FundSellResult-newYqbBuyResult-newYqbSellResult","FundSellResult":"FundSellResult","newYqbBuyResult":"newYqbBuyResult","dueDate":"dueDate","historyBonusDetail":"historyBonusDetail","historyLog":"historyLog","historyLogDetail":"historyLogDetail","newFundDetailTradingRules":"newFundDetailTradingRules","newFundDocument":"newFundDocument","newFundList":"newFundList","newYqbBonusOrder":"newYqbBonusOrder","newYqbBuyOrder":"newYqbBuyOrder","newYqbBuyType":"newYqbBuyType","newYqbDesc":"newYqbDesc","newYqbPositionDetail":"newYqbPositionDetail","newYqbRecordList":"newYqbRecordList","newYqbSellOrder":"newYqbSellOrder","newYqbSellOrderSon":"newYqbSellOrderSon","onlyReadyActivity":"onlyReadyActivity","outsideTrusteeFunds":"outsideTrusteeFunds","outsideTrusteeReord":"outsideTrusteeReord","outsideTrusteeResult":"outsideTrusteeResult","regularInvestBuyResult":"regularInvestBuyResult","regularInvestCompany":"regularInvestCompany","regularInvestPlan":"regularInvestPlan","transactionAllLog":"transactionAllLog","transactionLog":"transactionLog","transactionLogDetailMR":"transactionLogDetailMR","transactionLogDetailRG":"transactionLogDetailRG","transactionLogDetailTransfer":"transactionLogDetailTransfer","transactionLogDetailView":"transactionLogDetailView","transactionLogDetailViewSon":"transactionLogDetailViewSon","transactionLogDetailViewSonFH":"transactionLogDetailViewSonFH","transactionLogDetailViewSonMC":"transactionLogDetailViewSonMC","transactionLogDetailViewSonQJ":"transactionLogDetailViewSonQJ","transactionLogDetailViewSonQP":"transactionLogDetailViewSonQP","transactionLogDetailViewSonQS":"transactionLogDetailViewSonQS","transactionLogDetailViewSonQZ":"transactionLogDetailViewSonQZ","transactionLogDetailViewSonWZTG":"transactionLogDetailViewSonWZTG","transactionLogDetailViewSonZTG":"transactionLogDetailViewSonZTG","transactionLogDetailZTG":"transactionLogDetailZTG","newYqbSellResult":"newYqbSellResult","vendors-visitorDetails":"vendors-visitorDetails","visitorDetails":"visitorDetails"}[chunkId]||chunkId) + "." + "4692bc63f7a37ba37b04" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.puzefund.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"base-app","libs-app","charts-app","vendors-app"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
